import React from "react";
import { Outlet } from "react-router-dom";
import { Shield, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function SiswaLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-navy-900 text-white px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-3 no-print">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-sm bg-brass-500 flex items-center justify-center flex-shrink-0">
            <Shield className="w-5 h-5 text-navy-900" />
          </div>
          <div className="min-w-0">
            <div className="font-heading font-bold text-xs sm:text-sm uppercase tracking-widest truncate">Penilaian Sosiometri</div>
            <div className="text-[10px] text-brass-400 uppercase tracking-wider">Portal Serdik</div>
          </div>
        </div>
        <div className="flex items-center gap-3 sm:gap-4 flex-shrink-0">
          <div className="text-right hidden sm:block">
            <div className="text-xs text-white/60 uppercase">Selamat datang,</div>
            <div className="font-semibold text-sm">{user?.nama}</div>
          </div>
          <button onClick={logout} data-testid="logout-btn" className="px-3 py-2 bg-navy-800 hover:bg-red-900 text-white/80 hover:text-white text-sm rounded-sm transition-colors flex items-center gap-2">
            <LogOut className="w-4 h-4" /> Keluar
          </button>
        </div>
      </header>
      <main><Outlet /></main>
    </div>
  );
}
